import { BullModule } from '@nestjs/bullmq'
import { Module } from '@nestjs/common'
import { GOOGLE_RESERVATIONS_QUEUES } from '../../../../../core'
import { RealtimeUpdateProcessor } from './realtime-update.processor'
import {
	UploadAvailabilityFeedProcessor,
	UploadMerchantFeedProcessor,
	UploadServicesFeedProcessor,
} from './upload-feed'

@Module({
	imports: [
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.SEND_REALTIME_UPDATE,
		}),
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.UPLOAD_MERCHANT_FEED,
		}),
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.UPLOAD_SERVICES_FEED,
		}),
		BullModule.registerQueue({
			name: GOOGLE_RESERVATIONS_QUEUES.UPLOAD_AVAILABILITY_FEED,
		}),
	],
	providers: [
		RealtimeUpdateProcessor,
		UploadMerchantFeedProcessor,
		UploadServicesFeedProcessor,
		UploadAvailabilityFeedProcessor,
	],
})
export class GoogleReservationsProcessorModule {}
